import * as React from "react";
import Autoplay from "embla-carousel-autoplay";
import { Card, CardContent } from "../ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { useEffect } from "react";
export function CarouselDestacados({ delay = 10000, products }) {
  useEffect(() => {}, [products]);

  return (
    <Carousel
      plugins={[
        Autoplay({
          delay: delay,
        }),
      ]}
      opts={{
        align: "start",
        loop: true,
      }}
      className="w-full"
    >
      <CarouselContent className="">
        {products.map((product, index) => (
          <CarouselItem
            key={index}
            className=" md:basis-1/2 lg:basis-1/3 border-none "
          >
            <div className="p-1">
              <Card className="border-none shadow-none">
                <CardContent className="flex aspect-square items-center justify-center p-6 shadow-none">
                  <img
                    src={process.env.REACT_APP_S3_ENDPOINT + "/" + product.image_url}
                    alt="mariposa"
                    className="h-[90%] max-h-[400px] w-full object-contain "
                  />
                </CardContent>
              </Card>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="text-mariposa bg-none ml-2 hover:bg-mariposa hover:text-white" />
      <CarouselNext className="text-mariposa bg-none mr-2 hover:bg-mariposa hover:text-white" />
    </Carousel>
  );
}
